@if (show) {
  <div
    class="map-request-context-menu"
    role="menu"
    [attr.aria-label]="'MAP_REQUEST.MENU_CREATE_REQUEST' | translate"
    [style.top.px]="position.top"
    [style.left.px]="position.left"
    (keydown)="onMenuKeydown($event)">
    <button type="button" class="context-menu-item" role="menuitem" (click)="onCreateRequest()">
      <i class="pi pi-send" aria-hidden="true"></i>
      <span>{{ 'MAP_REQUEST.MENU_CREATE_REQUEST' | translate }}</span>
    </button>
  </div>
}
